import { createContext, useContext } from 'react';
import * as setup from '../../setup';

const defaultData = {
    footer: setup.footer,
    general: setup.general,
    header: setup.header,
    landing: setup.landing,
    survey: setup.survey,
};

const ContentContext = createContext<ContentState>({} as ContentState);

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }: ContentProviderProps) {
    const state = {
        ...defaultData,
        reload: () => {},
    };

    return <ContentContext.Provider value={state}>{children}</ContentContext.Provider>;
}
